import * as actionTypes from '../actionTypes/Quiz'

export const setQuizSets = quizSets => {
    return {
        type: actionTypes.SET_QUIZ_SETS,
        quizSets,
    }
}

export const setQuizSet = quizSet => {
    return {
        type: actionTypes.SET_QUIZ_SET,
        quizSet,
    }
}

export const setError = message => {
    return {
        type: actionTypes.SET_ERROR_MESSAGE,
        message,
    }
}

export const setQuizId = quizId => {
    return {
        type: actionTypes.SET_QUIZ_ID,
        quizId,
    }
}

export const setActiveQuestion = (quiz, question) => {
    return {
        type: actionTypes.SET_ACTIVE_QUESTION,
        quiz,
        question,
    }
}

export const resetStateRequest = () => ({
    type: actionTypes.RESET_STATE,
})
